export default __webpack_public_path__ + "static/media/sad-look.bfdab12f.gif";